import { Component, Input, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { Estacion, Negocios, Region, RelacionUsuario, Rol, UsuarioConfig } from 'src/app/types/Entitys';
declare var $: any;

@Component({
  selector: 'app-form-config-user',
  templateUrl: './form-config-user.component.html',
  styleUrls: ['./form-config-user.component.css']
})
export class FormConfigUserComponent {
  @Input() negocios: Negocios[];
  @Input() roles: Rol[];
  @Input() usuario: UsuarioConfig;
  regiones: Region[];
  estaciones: Estacion[];
  form: FormGroup;
  lblEstacion: string = 'Estación/Sitio';
  isSuper = true;

  constructor(private formBuilder: FormBuilder, private userService: UsuariosService) {
    this.buildForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setValuesToForm(changes['usuario']);
  }

  private buildForm() {
    this.form = this.formBuilder.group({
      negocio: ['0', [Validators.required]],
      region: ['0', [Validators.required]],
      estacion: ['0', [Validators.required]],
      rol: ['0', [Validators.required]],
    });
  }

  get negocio() {
    return this.form.get('negocio')
  }

  get region() {
    return this.form.get('region')
  }

  changeRegiones(event: Event) {
    const inpunt = event.target as HTMLInputElement;
    const idNegocio = parseInt(inpunt.value)

    if (idNegocio === 1)
      this.lblEstacion = 'Estación';
    else if (idNegocio === 2)
      this.lblEstacion = 'Sitios';

    this.userService.getCatalogoRegiones({ Negocio_Id: idNegocio })
      .subscribe(resp => {
        if (resp?.Result?.Exito) {
          this.regiones = resp.Result.Data as Region[]
          this.form.patchValue({ estacion: '0' })
        }
        else
          Utilerias.alertClient('', resp?.Result?.Error, 1);
      })
  }

  changeEstaciones(event: Event) {
    const inpunt = event.target as HTMLInputElement;
    const idRegion = parseInt(inpunt.value)
    this.userService.getEstaciones(idRegion)
      .subscribe(resp => {
        if (resp?.Result?.Exito)
          this.estaciones = resp.Result.Data as Estacion[]
      })
  }

  guardarRelacionUsario() {
    const { IdEmpleado } = this.usuario;
    const { negocio, region, estacion, rol } = this.form.value
    const relacion: RelacionUsuario = {
      IdEmpleado,
      IdNegocio: negocio,
      IdRegion: region,
      IdEstacion: estacion,
      IdRol: rol
    };
    this.userService.postRelacionUsuarioRegionEstacion({ rel: relacion })
      .subscribe(data => {
        if (data.Result.Exito) {
          $("#modalRelacionRegion").modal('toggle');
          this.resetForm();
        }
      });
  }

  setValuesToForm(isUserChange: SimpleChange) {
    if (isUserChange && isUserChange.currentValue !== isUserChange.previousValue) {
      if (this.usuario.IdNegocio && this.usuario.IdRegion) {
        this.userService.fetchRegionesEstaciones({ IdNegocio: this.usuario.IdNegocio, IdRegion: this.usuario.IdRegion })
          .subscribe(([regiones, estaciones]) => {
            if (regiones?.Result?.Exito && estaciones?.Result?.Exito && estaciones?.Result?.Data) {
              this.regiones = regiones.Result.Data as Region[]
              this.estaciones = estaciones.Result.Data as Estacion[]

              this.form.setValue({
                negocio: this.usuario.IdNegocio,
                region: this.usuario.IdRegion,
                estacion: this.usuario.IdEstacion,
                rol: this.usuario.IdRol
              })

              this.isSuper = this.validRol();
            }
          })
      }
    }
  }

  resetForm() {
    this.form.reset({
      negocio: 0,
      region: 0,
      estacion: 0,
      rol: 0
    })
  }

  validRol() {
    if (this.roles && this.usuario) {
      const isSuper = this.roles.some(rol => rol.IdRol === this.usuario.IdRol)
      return isSuper ? true : false;
    }
    return false;
  }
}

